import Home from './home-components/home.js';
import About from './home-components/about.js';
import Projects from './home-components/projects.js';
import Skills from './home-components/skills.js';
import Testimonial from './home-components/testimonials.js';
import Contact from './home-components/contact.js';
import Footer from './home-components/footer.js';
function App() {
  return (
    <div>
      <div className="head">
      <Home/>
      </div>
    

        <div className="head">
        <About/>
        </div>
 

     <hr/>

    <div className="head">
    <Projects/>
    </div>
 
      <hr />
    <div className="head mr-2 ml-2 bg-gray-200">
    <Skills/>
    </div>
  
    
          <hr />
          <div className="head mr-2 ml-2 ">
              <Testimonial/>
            </div>
  
    
          <hr />
    <div className="head">
          
    <Contact/>
    </div>
  <div>
    <Footer/>
  </div>
    </div>
  );
}

export default App;
